import { observer } from "mobx-react";
import React, { FC } from "react";
import loginImage from "../../../assets/images/logo/logo-removebg.png";
import SigninForm from "../../ScreenLogin/SigninForm";
import {
  StyledMedia,
  StyledMediaBody,
  StyledImage,
  StyledSignin,
} from "./style";

type Props = {
  handleLogin: (email: string, password: string) => any;
};

const AuthContainer: FC<Props> = observer(({ handleLogin }) => {
  return (
    <StyledMedia>
      <StyledMediaBody>
        <StyledImage>
          <img src={loginImage} alt="Login" />
        </StyledImage>
      </StyledMediaBody>
      <StyledSignin>
        <SigninForm handleLogin={handleLogin} />
      </StyledSignin>
    </StyledMedia>
  );
});

export default AuthContainer;
